import * as React from 'react';

function VIPLoungeIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 25 24" fill="none" {...props}>
			<g clipPath="url(#prefix__clip0_26449_425397)">
				<path
					d="M22.658 5.846c-1.018 0-1.843.8-1.843 1.788 0 .326.092.632.25.895L17.45 11.16l-3.884-4.713a1.77 1.77 0 00.775-1.456c0-.987-.825-1.788-1.842-1.788-1.018 0-1.842.8-1.842 1.788 0 .601.306 1.132.775 1.456L7.551 11.16 3.935 8.53c.158-.264.25-.57.25-.896 0-.988-.825-1.788-1.843-1.788-1.017 0-1.842.8-1.842 1.788 0 .816.564 1.503 1.334 1.717.001.024 0 .048.003.072L3.023 19.78c.065.584.574 1.024 1.178 1.024h16.598c.606 0 1.113-.44 1.181-1.024l1.183-10.356c.003-.024.002-.048.003-.072.77-.214 1.334-.901 1.334-1.717 0-.988-.825-1.788-1.842-1.788z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="prefix__clip0_26449_425397">
					<path
						fill="currentColor"
						transform="translate(.5)"
						d="M0 0h24v24H0z"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

const MemoVIPLoungeIcon = React.memo(VIPLoungeIcon);
export default MemoVIPLoungeIcon;
